import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Orientation } from '@getgo/chameleon-core';
import { RadioButton, RadioGroup } from '@getgo/chameleon-web-react-wrapper';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import classes from './index.module.scss';
import PageIcon from './PageIcon';
export var Positions;
(function (Positions) {
    Positions["LEFT"] = "LEFT";
    Positions["RIGHT"] = "RIGHT";
})(Positions || (Positions = {}));
export const PositionSelect = ({ value = Positions.LEFT, className, onChange, disabled, }) => {
    const { t } = useTranslation();
    return (_jsxs(RadioGroup, Object.assign({ className: classNames(classes.positionSelect, className), orientation: Orientation.horizontal, value: value, name: "PositionSelect", onChange: event => {
            onChange(event.currentTarget.value);
        } }, { children: [_jsx(PageIcon, { className: classes.positionSelect__icon }, void 0), _jsx(PageIcon, { className: classNames(classes.positionSelect__icon, classes.positionSelect__icon_right) }, void 0), _jsx(RadioButton, Object.assign({ disabled: disabled, value: Positions.LEFT, className: classes.positionSelect__radio }, { children: t('Bottom left') }), void 0), _jsx(RadioButton, Object.assign({ disabled: disabled, value: Positions.RIGHT, className: classes.positionSelect__radio }, { children: t('Bottom right') }), void 0)] }), void 0));
};
//# sourceMappingURL=index.js.map